<template>
    <div class="modal modal-confirm modal-shift fade" :id="modalId" tabindex="-1" role="dialog" :aria-labelledby="modalId" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="header-wrap">
                        <span :class="{ 'color--green': shiftStatus === 'Active', 'color--red': shiftStatus !== 'Active' }">{{ shiftStatus }}</span>
                        <span>|</span>
                        <span>{{ shift.client.name }}</span>
                    </div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="modal-inner">

                        <div class="customise-tabs">
                            <div class="nav-tabs-wrap  pb-2">
                                <div class="block-with-shifts">
                                    <div class="table-shifts-holder">
                                        <table class="table shifts-table">
                                            <thead>
                                            <tr>
                                                <th >Mon</th>
                                                <th>Tue</th>
                                                <th>Wed</th>
                                                <th>Thu</th>
                                                <th>Fri</th>
                                                <th>Sat</th>
                                                <th>Sun</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td class="text-center">
                                                    <div
                                                        class="shift-block-adm-shifts"
                                                        v-for="(shifts, index) in shift.schedule.monday"
                                                        :key="index + 'monday'"
                                                    >
                                                        <div>{{ shifts }}</div>
                                                    </div>
                                                </td>
                                                <td class="text-center">
                                                    <div
                                                        v-for="(shifts, index) in shift.schedule.tuesday"
                                                        :key="index + 'tuesday'"
                                                        class="shift-block-adm-shifts"
                                                    >
                                                        <div>{{ shifts }}</div>
                                                    </div>
                                                </td>
                                                <td class="text-center">
                                                    <div
                                                        class="shift-block-adm-shifts"
                                                        v-for="(shifts, index) in shift.schedule.wednesday"
                                                        :key="index + 'wednesday'"
                                                    >
                                                        <div>{{ shifts }}</div>
                                                    </div>
                                                </td>
                                                <td class="text-center">
                                                    <div
                                                        v-for="(shifts, index) in shift.schedule.thursday"
                                                        :key="index + 'thursday'"
                                                        class="shift-block-adm-shifts">
                                                        <div>{{ shifts }}</div>
                                                    </div>
                                                </td>
                                                <td class="text-center">
                                                    <div
                                                        class="shift-block-adm-shifts"
                                                        v-for="(shifts, index) in shift.schedule.friday"
                                                        :key="index + 'friday'">
                                                        <div>{{ shifts }}</div>
                                                    </div>
                                                </td>
                                                <td class="text-center">
                                                    <div
                                                        v-for="(shifts, index) in shift.schedule.saturday"
                                                        :key="index + 'saturday'"
                                                        class="shift-block-adm-shifts"
                                                    >
                                                        <div>{{ shifts }}</div>
                                                    </div>
                                                </td>
                                                <td class="text-center">
                                                    <div
                                                        class="shift-block-adm-shifts"
                                                        v-for="(shifts, index) in shift.schedule.sunday"
                                                        :key="index + 'sunday'"
                                                    >
                                                        <div>{{ shifts }}</div>
                                                    </div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="right-block">
                                        <ul class="nav nav-tabs nav-tabs-three">
                                            <li class="nav-item">
                                                <a
                                                    href="javascript:void(0)"
                                                    class="nav-link"
                                                    :class="{ 'active': this.activeList === 'requested' }"
                                                    @click="changeTab('requested')">Requested</a>
                                            </li>
                                            <li class="nav-item">
                                                <a
                                                    href="javascript:void(0)"
                                                    class="nav-link"
                                                    :class="{ 'active': this.activeList === 'hidden' }"
                                                    @click="changeTab('hidden')">Hidden</a>
                                            </li>
                                            <li class="nav-item">
                                                <a
                                                    href="javascript:void(0)"
                                                    class="nav-link"
                                                    :class="{ 'active': this.activeList === 'approved' }"
                                                    @click="changeTab('approved')">Approved</a>
                                            </li>
                                        </ul>
                                        <div class="mt-3 small-text" v-show="activeList === 'hidden'">Employees/Applicants that have been added to the hidden list will disappear after 90 days. When they are removed from this list, they will again be able to ‘volunteer’ for the shift on their applicant/employee portal.</div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-content">
                                <div class="tab-pane fade show active">
                                    <div class="text-scroll" style=" overflow-y: auto;max-height: 21.0625rem;">
                                        <div class="table-holder table-responsive">
                                            <table class="table">
                                                <thead>
                                                <tr>
                                                    <th></th>
                                                    <th class="text-left">Name</th>
                                                    <th class="text-center" >Stages</th>
                                                    <th  class="text-center">Location</th>
                                                    <th class="text-center" style="width: 10rem">Action</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr
                                                    v-for="applicant in listOfRequests"
                                                    :key="applicant.id"
                                                >
                                                    <td class="avatar-col">
                                                        <div class="user-info">
                                                            <div
                                                                class="avatar"
                                                                :style="{'background-image': applicant.avatar ? `url(${applicant.avatar})` : 'url(/img/svg/emptyAvatar.png)'}">
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td class="text-left">
                                                        <div class="user-info">
                                                            <div class="name">{{applicant.name}} {{applicant.last_name}}</div>
                                                        </div>
                                                    </td>
                                                    <td class="text-center">
                                                        {{ applicant.stages ?? '' }}
                                                    </td>
                                                    <td class="text-center">
                                                       {{applicant.user_address?.address ?? ''}}
                                                    </td>
                                                    <td class="text-center">
                                                        <div class="btn-mod-wrap"  style="justify-content: center">
                                                            <button
                                                                v-show="activeList === 'requested' || activeList === 'approved'"
                                                                class="btn btn--outline-primary btn--narrow"
                                                                @click="changeStatus('hidden', applicant.id, )"
                                                            >Hide</button>
                                                            <button
                                                                v-show="activeList === 'requested'"
                                                                class="btn  btn--narrow"
                                                                @click="changeStatus('approved', applicant.id, )"
                                                            >Approve</button>
                                                            <button
                                                                v-show="activeList === 'hidden'"
                                                                class="btn  btn--narrow"
                                                                @click="changeStatus('requested', applicant.id)"
                                                            >Move to Requested</button>
                                                        </div>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ShiftBoardService from "./services/ShiftBoardService";

export default {
    name: 'ShiftModal',
    props: {
        modalId: {
            type: String,
            required: true,
        },
        shiftInfo: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            shift: this.shiftInfo,
            listOfRequests: [],
            activeList: 'requested'
        }
    },
    computed: {
        shiftStatus() {
           if (this.shift.status === 1) {
               return "Active"
           } else {
               return "Inactive"
           }
        }
    },
    methods: {
        changeTab(listName) {
            this.activeList = listName
            this.showCurrentList(listName);
        },
        showCurrentList(listName) {
            this.listOfRequests = this.shift.applicants.filter(applicant => {
                return applicant.pivot.status === listName;
            });
        },
        setApplicantStatus(applicant_id, newStatus) {
            const foundApplicant = this.shift.applicants.find(applicant => applicant.id === applicant_id);
            if (foundApplicant) {
                foundApplicant.pivot.status = newStatus;
                this.listOfRequests = this.shift.applicants.filter(applicant => applicant.pivot.status === newStatus);
            } else {
                console.error(`Applicant with ID ${applicant_id} not found.`);
            }
        },
        async changeStatus(newStatus, applicant_id) {
            this.$showLoadingMessage()
            try {
                await ShiftBoardService.changeApplicantsStatus(this.shift.id, applicant_id, newStatus);
                this.$showSuccessMessage('Information updated!')
                this.setApplicantStatus(applicant_id, newStatus);
                this.changeTab(this.activeList)
            } catch(e) {
                this.$showErrorMessage('Information was not updated. Please try again.');
            }
        }
    },
    mounted() {
        this.changeTab('requested')
    }
}

</script>

<style scoped>

</style>
